@if (tourService.activeStep(); as step) {
    @switch (step.mode) {
        @case ('fullscreen') {
            <div class="fixed inset-0 z-[2000] bg-base-300 flex items-center justify-center p-4 overflow-y-auto">
                <div class="card bg-base-100 shadow-xl max-w-lg w-full my-8">
                    <div class="card-body items-center text-center gap-4">
                        @if (step.title) {
                            <h2 class="text-xl font-bold text-base-content font-[Dosis]">{{ step.title }}</h2>
                        }
                        <p class="text-sm text-base-content/70 font-[Lato]">{{ step.text }}</p>

                        @switch (step.id) {
                            @case ('p0-welcome') {
                                <div class="w-full aspect-video rounded-xl overflow-hidden bg-black">
                                    <iframe [src]="welcomeVideoUrl"
                                            class="w-full h-full"
                                            frameborder="0"
                                            allow="autoplay; fullscreen; picture-in-picture"
                                            allowfullscreen>
                                    </iframe>
                                </div>
                            }
                            @case ('p0-avatar') {
                                @if (avatarCropperFile) {
                                    <div class="flex flex-col items-center gap-4 w-full">
                                        <image-cropper
                                            [imageFile]="avatarCropperFile"
                                            [maintainAspectRatio]="true"
                                            [aspectRatio]="1"
                                            [roundCropper]="true"
                                            [resizeToWidth]="400"
                                            [output]="'base64'"
                                            format="jpeg"
                                            (imageCropped)="onAvatarCropped($event)"
                                            class="max-h-72 w-full block">
                                        </image-cropper>
                                        <div class="flex gap-3">
                                            <button type="button" class="btn btn-ghost gap-2" (click)="cancelAvatarCrop()">
                                                <i class="fas fa-times"></i> Abbrechen
                                            </button>
                                            <button type="button" class="btn btn-primary gap-2" (click)="applyAvatarCrop()">
                                                <i class="fas fa-check"></i> Übernehmen
                                            </button>
                                        </div>
                                    </div>
                                } @else {
                                    <button (click)="avatarFileInput.click()" class="relative">
                                        <div class="w-24 h-24 rounded-full bg-gradient-to-br from-primary via-secondary to-accent text-white font-bold flex items-center justify-center cursor-pointer hover:scale-105 transition-transform overflow-hidden">
                                            @if (avatarPreviewUrl) {
                                                <img [src]="avatarPreviewUrl" alt="Profilbild-Vorschau" class="w-full h-full object-cover rounded-full">
                                            } @else {
                                                <i class="fas fa-camera text-2xl"></i>
                                            }
                                        </div>
                                        <div class="absolute -bottom-1 -right-1 w-7 h-7 bg-primary text-white rounded-full flex items-center justify-center border-2 border-base-100">
                                            <i class="fas fa-camera text-xs"></i>
                                        </div>
                                    </button>
                                    <input #avatarFileInput type="file" accept="image/*" class="hidden" (change)="onAvatarFileSelected($event)">
                                    <p class="text-xs text-base-content/50">PNG, JPG oder GIF bis 5MB — kann auch später ergänzt werden.</p>
                                }
                            }
                            @case ('p0-bio') {
                                <textarea [(ngModel)]="bioText" maxlength="500" rows="4"
                                          placeholder="z.B. Ich bin seit 10 Jahren in der Erwachsenenbildung tätig und freue mich auf den Austausch mit euch."
                                          class="textarea textarea-bordered w-full resize-none"></textarea>
                                <p class="text-xs text-base-content/40 self-end">{{ bioText.length }}/500</p>
                            }
                        }

                        <button class="btn btn-primary w-full gap-2" [disabled]="!canAdvanceFullscreen()" (click)="onFullscreenPrimary()">
                            @if (saving()) {
                                <span class="loading loading-spinner loading-xs"></span>
                            }
                            {{ step.buttonLabel || 'Weiter' }}
                        </button>
                    </div>
                </div>
            </div>
        }
        @case ('interstitial') {
            <div class="fixed inset-0 z-[2000] bg-black/60 flex items-center justify-center p-4">
                <div class="card bg-base-100 shadow-xl max-w-md w-full">
                    <div class="card-body items-center text-center gap-4">
                        <h3 class="text-lg font-bold text-base-content font-[Dosis]">Wie geht's weiter?</h3>
                        <p class="text-sm text-base-content/70 font-[Lato]">
                            Du kennst jetzt die FreyMuT-Community. Als nächstes zeigen wir dir deinen eigenen Kurs — oder du schaust dich erstmal in Ruhe um.
                        </p>
                        <div class="flex flex-col gap-2 w-full">
                            <button class="btn btn-primary w-full" (click)="tourService.chooseContinueNow()">
                                Jetzt weiter zu deinem Kurs
                            </button>
                            <button class="btn btn-ghost w-full" (click)="tourService.chooseLater()">
                                Später, ich schau mich erst um
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        }
        @case ('spotlight') {
            @if (tourService.targetRect(); as rect) {
                @for (r of backdropRects(rect); track $index) {
                    <div class="fixed bg-black/60 z-[2000] pointer-events-auto"
                         [style.top]="r['top']" [style.left]="r['left']" [style.width]="r['width']" [style.height]="r['height']">
                    </div>
                }
                <div class="fixed z-[2001] rounded-lg ring-4 ring-primary pointer-events-none transition-all duration-200"
                     [style.top]="ringStyle(rect)['top']" [style.left]="ringStyle(rect)['left']"
                     [style.width]="ringStyle(rect)['width']" [style.height]="ringStyle(rect)['height']">
                </div>
                <div class="fixed z-[2010] transition-all duration-200"
                     [style.top]="bubbleStyle(rect)['top']" [style.left]="bubbleStyle(rect)['left']" [style.width]="bubbleStyle(rect)['width']">
                    <div class="card bg-base-100 shadow-xl">
                        <div class="card-body p-4 gap-2">
                            <p class="text-sm text-base-content font-[Lato]">{{ step.text }}</p>
                            @if (step.advanceOn === 'targetClick') {
                                <p class="text-xs text-primary/70 italic">
                                    <i class="fas fa-hand-pointer mr-1"></i>Klicke auf das markierte Element, um fortzufahren.
                                </p>
                            }
                            <div class="flex justify-between items-center mt-1">
                                @if (step.skippable) {
                                    <button class="btn btn-ghost btn-xs" (click)="tourService.skip()">Überspringen</button>
                                }
                                @if (step.advanceOn === 'button') {
                                    <button class="btn btn-primary btn-sm ml-auto" (click)="tourService.advance()">
                                        {{ step.buttonLabel || 'Weiter' }}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <div class="fixed inset-0 bg-black/50 z-[2000]"></div>
                <div class="fixed inset-0 z-[2010] flex items-center justify-center p-4">
                    <div class="card bg-base-100 shadow-xl max-w-xs">
                        <div class="card-body p-4 items-center gap-2">
                            <span class="loading loading-spinner loading-sm text-primary"></span>
                            <p class="text-sm text-base-content/60 font-[Lato]">Einen Moment...</p>
                        </div>
                    </div>
                </div>
            }
        }
    }
}

@if (tourService.resumeHintVisible()) {
    <button class="fixed bottom-6 right-6 z-[2000] btn btn-primary btn-sm shadow-lg gap-2"
            (click)="tourService.resumeFromHint()">
        <i class="fas fa-route"></i> Tour fortsetzen
    </button>
}
